<!--<plat-top-menu>-->
	<!--<div class="switch-group">-->
		<!--<checkbox-->
			<!--*ngIf="!(hideXenaNeoSwitch$ | async)"-->
			<!--[ngModel]="(showNeoFrame$ | async)"-->
			<!--[uncheckedLabel]="activatedRouteName"-->
			<!--(ngModelChange)="closeNeoFrame($event)"-->
			<!--label="NEO"-->
			<!--type="switch"-->
		<!--&gt;</checkbox>-->
	<!--</div>-->
<!--</plat-top-menu>-->


<go-suite-loader *ngIf="!argusLoaded"></go-suite-loader>
<iframe [src]="argusUrl$ | async" #argusFrame *ngIf="(argusUrl$ | async)"></iframe>



// WEBPACK FOOTER //
// ./src/app/argus-frame/argus-frame.component.html